import styled from 'styled-components'

import {
  COLORS,
  composeUtilsSelector,
  focusWithInSelector,
  hover,
  hoverSelector,
  THEME,
  typeScale,
} from '../../styles'
import Icon from '../Icon'

const Styled = styled.div``
Styled.smiley = styled(Icon)`
  display: block;
  width: 3.6rem;
  height: 3.6rem;
`
Styled.bubbleIcon = styled(Icon)`
  & * {
    transition: fill 0.2s ease-out;
  }
`
Styled.bubble = styled.div`
  border-radius: 9999px;
  width: 2.4rem;
  height: 2.4rem;
  padding: 0.4rem;
  background-color: ${THEME.COLORS.foreground.tertiary};
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  transition:
    background-color 0.2s ease-out,
    opacity 0.2s ease-out;
  opacity: 0;
  ${hover`
    background-color: ${COLORS.primary};
  `}
  ${hoverSelector(Styled.bubbleIcon)`
    & * {
      fill: ${COLORS.white};
    }
  `}
`
Styled.wrapper = styled.div`
  padding: 0;
  position: relative;
  ${({ allowAction }) =>
    allowAction
      ? composeUtilsSelector(hoverSelector, focusWithInSelector)(Styled.bubble)`
    opacity: 1;
  `
      : null}
  ${({ displayAction }) =>
    displayAction
      ? `
    & ${Styled.bubble} {
      opacity: 1;
    }
  `
      : ''}
`
Styled.content = styled.div`
  position: relative;
`
Styled.author = styled.div`
  padding-bottom: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
Styled.authorName = styled.p`
  ${typeScale('body', { fontWeight: 'bold' })}
  text-align: left;
  line-height: normal;
  text-transform: capitalize;
  display: inline-block;
  color: ${THEME.COLORS.foreground.primary};
`
Styled.authorMe = styled.span`
  ${typeScale('body', { fontWeight: 'normal' })}
  color: ${THEME.COLORS.foreground.secondary};
`
Styled.authorRating = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.8rem;
`
Styled.authorRatingIcon = styled(Icon)``
Styled.authorRatingText = styled.span`
  color: ${THEME.COLORS.foreground.primary};
  ${typeScale('caption')};
  display: inline-block;
  padding-left: 0.2rem;
`
Styled.description = styled.p`
  ${typeScale('caption')};
  color: ${({ isHidden }) =>
    isHidden
      ? THEME.COLORS.foreground.secondary
      : THEME.COLORS.foreground.primary};

  &:first-letter {
    text-transform: uppercase;
  }
`
Styled.descriptionDate = styled.em`
  color: ${THEME.COLORS.foreground.secondary};
`
Styled.usefulText = styled.div`
  ${typeScale('caption', { lineHeight: 'normal' })};
  color: ${({ isLikedByUser }) =>
    isLikedByUser ? COLORS.primary : THEME.COLORS.foreground.secondary};
  display: inline-block;
  padding-right: 0.4rem;
  transition: color 0.2s ease-in-out;
`
Styled.usefulIcon = styled(Icon)`
  width: 2.4rem;
  height: 2.4rem;

  & * {
    transition: fill 0.2s ease-in-out;
  }
`
Styled.useful = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding-top: 0.4rem;
  cursor: ${({ isFeedbackAuthor, canLike }) =>
    isFeedbackAuthor || !canLike ? 'default' : 'pointer'};
  ${({ isFeedbackAuthor, canLike }) => hoverSelector(Styled.usefulText)`
    color: ${
      isFeedbackAuthor || !canLike
        ? THEME.COLORS.foreground.secondary
        : COLORS.primary
    }
  `}
  ${({ isFeedbackAuthor, canLike }) => hoverSelector(Styled.usefulIcon)`
    & * {
      fill: ${
        isFeedbackAuthor || !canLike
          ? THEME.COLORS.foreground.secondary
          : COLORS.primary
      };
    }
  `};
`
Styled.reply = styled.div`
  padding: 0.8rem 0 0 4.4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`
Styled.replyContent = styled.div`
  padding-left: 0.8rem;
`
Styled.replyAuthor = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.4rem;
  align-items: center;
  justify-content: flex-start;
`
Styled.replyAuthorIcon = styled.div`
  background-color: ${COLORS.primary};
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
`
Styled.replyAuthorText = styled.p`
  ${typeScale('body', { fontWeight: 'bolder' })};
  padding-left: 0.8rem;
`
Styled.replyText = styled.p`
  ${typeScale('caption')}
`

export default Styled
